/* 🤖 this file was generated by svg-to-ts */

export type IconName =
  | 'apple_podcasts_logo_duotone'
  | 'arrow_fat_lines_right_duotone'
  | 'barbell_duotone'
  | 'barcode_duotone'
  | 'bell_duotone'
  | 'binoculars_duotone'
  | 'book_open_text_duotone'
  | 'bookmark_simple_duotone'
  | 'books_duotone'
  | 'briefcase_duotone'
  | 'bug_duotone'
  | 'calendar_blank_duotone'
  | 'chart_bar_horizontal_duotone'
  | 'chart_bar_vertical_duotone'
  | 'chart_line_up_duotone'
  | 'chat_centered_duotone'
  | 'chat_centered_text_duotone'
  | 'chats_duotone'
  | 'check_circle_duotone'
  | 'circle_half_tilt_duotone'
  | 'clipboard_plus_duotone'
  | 'clipboard_text_duotone'
  | 'clock_duotone'
  | 'closed_captioning_duotone'
  | 'cloud_arrow_down_duotone'
  | 'cloud_arrow_up_duotone'
  | 'cloud_check_duotone'
  | 'cloud_duotone'
  | 'cobot_line_duotone'
  | 'codepen_logo_duotone'
  | 'cookie_duotone'
  | 'copy_duotone'
  | 'copyright_duotone'
  | 'credit_card_duotone'
  | 'crop_duotone'
  | 'crosshair_duotone'
  | 'cube_duotone'
  | 'currency_dollar_simple_duotone'
  | 'cylinder_duotone'
  | 'database_duotone'
  | 'desktop_duotone'
  | 'device_duotone'
  | 'dots_three_horisontal_duotone'
  | 'dots_three_vertical_duotone'
  | 'drop_duotone'
  | 'envelope_open_duotone'
  | 'eraser_duotone'
  | 'eye_duotone'
  | 'eye_slash_duotone'
  | 'eyec_closed_duotone'
  | 'facebook_logo_duotone'
  | 'file_arrow_down_duotone'
  | 'file_arrow_up_duotone'
  | 'file_doc_duotone'
  | 'file_html_duotone'
  | 'file_jpg_duotone'
  | 'file_pdf_duotone'
  | 'file_png_duotone'
  | 'file_ppt_duotone'
  | 'file_xls_duotone'
  | 'file_zip_duotone'
  | 'flame_duotone'
  | 'flask_duotone'
  | 'fork_knife_duotone'
  | 'funnel_duotone'
  | 'gauge_duotone'
  | 'gear_duotone'
  | 'ghost_duotone'
  | 'git_branch_duotone'
  | 'git_fork_duotone'
  | 'globe_duotone'
  | 'globe_stand_duotone'
  | 'graduation_cap_duotone'
  | 'graph_duotone'
  | 'handshake_duotone'
  | 'headset_duotone'
  | 'heart_duotone'
  | 'heartbeat_duotone'
  | 'house_duotone'
  | 'image_duotone'
  | 'info_duotone'
  | 'instagram_logo_duotone'
  | 'leaf_duotone'
  | 'linkedin_logo_duotone'
  | 'list_bullets_duotone'
  | 'list_checks_duotone'
  | 'list_plus_duotone'
  | 'lock_simple_duotone'
  | 'lock_simple_open_duotone'
  | 'magnifying_glass_duotone'
  | 'magnifying_glass_minus_duotone'
  | 'magnifying_glass_plus_duotone'
  | 'map_pin_duotone'
  | 'monitor_duotone'
  | 'moon_duotone'
  | 'needle_duotone'
  | 'notepad_duotone'
  | 'nut_duotone'
  | 'package_duotone'
  | 'paint_brush_broad_duotone'
  | 'pencil_duotone'
  | 'pencil_ruler_duotone'
  | 'person_simple_circle_duotone'
  | 'play_circle_duotone'
  | 'plugs_connected_duotone'
  | 'plugs_duotone'
  | 'printer_duotone'
  | 'question_duotone'
  | 'quotes_duotone'
  | 'repeat_duotone'
  | 'robot_duotone'
  | 'rocket_launch_duotone'
  | 'rows_duotone'
  | 'ruler_duotone'
  | 'scales_duotone'
  | 'selection_background_duotone'
  | 'share_network_duotone'
  | 'shield_check_duotone'
  | 'shield_duotone'
  | 'shipinhao_logo_duotone'
  | 'shopping_cart_duotone'
  | 'shuffle_duotone'
  | 'shuffle_up_duotone'
  | 'sliders_horizontal_duotone'
  | 'sliders_vertical_duotone'
  | 'smalldots_three_horisontal_duotone'
  | 'smalldots_three_vertical_duotone'
  | 'sparkle_duotone'
  | 'speaker_high_duotone'
  | 'speaker_slash_duotone'
  | 'speaker_x_duotone'
  | 'speed_high_duotone'
  | 'speed_low_duotone'
  | 'speed_medium_duotone'
  | 'spotify_logo_duotone'
  | 'square_half_horisontal_duotone'
  | 'square_half_vertical_duotone'
  | 'squares_four_duotone'
  | 'stack_duotone'
  | 'stamp_duotone'
  | 'star_duotone'
  | 'sticker_duotone'
  | 'student_duotone'
  | 'sun_duotone'
  | 'swap_duotone'
  | 'swatches_duotone'
  | 'syringe_duotone'
  | 'tag_duotone'
  | 'target_duotone'
  | 'telegram_logo_duotone'
  | 'test_tube_duotone'
  | 'thermometer_simple_duotone'
  | 'thumbs_down_duotone'
  | 'thumbs_up_duotone'
  | 'ticket_duotone'
  | 'tiktok_logo_duotone'
  | 'timer_duotone'
  | 'trash_duotone'
  | 'tree_duotone'
  | 'tree_evergreen_duotone'
  | 'truck_duotone'
  | 'twitter_logo_duotone'
  | 'user_circle_duotone'
  | 'user_duotone'
  | 'user_minus_duotone'
  | 'user_plus_duotone'
  | 'users_four_duotone'
  | 'users_three_duotone'
  | 'users_two_duotone'
  | 'warning_circle_duotone'
  | 'wechat_logo_duotone'
  | 'weishi_logo_duotone'
  | 'world_duotone'
  | 'wrench_duotone'
  | 'x_circle_duotone'
  | 'x_logo_duotone'
  | 'youtube_logo_duotone'
  | 'apple_podcasts_logo'
  | 'arrow_down_left_small'
  | 'arrow_down_left'
  | 'arrow_down_right_small'
  | 'arrow_down_right'
  | 'arrow_down_small'
  | 'arrow_down'
  | 'arrow_fat_lines_right'
  | 'arrow_left_small'
  | 'arrow_left'
  | 'arrow_right_small'
  | 'arrow_right'
  | 'arrow_square_in'
  | 'arrow_square_out'
  | 'arrow_up_left_small'
  | 'arrow_up_left'
  | 'arrow_up_right_small'
  | 'arrow_up_right'
  | 'arrow_up_small'
  | 'arrow_up'
  | 'arrows_down_up'
  | 'arrows_in'
  | 'arrows_out'
  | 'barbell'
  | 'bell'
  | 'binoculars'
  | 'book_open_text'
  | 'bookmark_simple'
  | 'books'
  | 'briefcase'
  | 'bug'
  | 'bullet'
  | 'calendar_blank'
  | 'caret_down_small'
  | 'caret_down'
  | 'caret_left_small'
  | 'caret_left'
  | 'caret_right_small'
  | 'caret_right'
  | 'caret_up_small'
  | 'caret_up'
  | 'chart_bar_horizontal'
  | 'chart_bar_vertical'
  | 'chart_line_up'
  | 'chat_centered_text'
  | 'chat_centered'
  | 'chats'
  | 'check_circle'
  | 'check'
  | 'circle_half_tilt'
  | 'circle_wavy_check'
  | 'clipboard_plus'
  | 'clipboard_text'
  | 'clock'
  | 'closed_captioning'
  | 'cloud_arrow_down'
  | 'cloud_arrow_up'
  | 'cloud_check'
  | 'cloud'
  | 'cobot_line'
  | 'codepen_logo'
  | 'cookie'
  | 'copy'
  | 'copyright'
  | 'corners_out'
  | 'credit_card'
  | 'crosshair'
  | 'cube'
  | 'currency_dollar_simple'
  | 'cylinder'
  | 'database'
  | 'desktop'
  | 'device'
  | 'dots_three_horisontal'
  | 'dots_three_vertical'
  | 'download_simple'
  | 'drop'
  | 'envelope_open'
  | 'eraser'
  | 'eye_slash'
  | 'eye'
  | 'facebook_logo'
  | 'file_arrow_down'
  | 'file_arrow_up'
  | 'file_doc'
  | 'file_html'
  | 'file_jpg'
  | 'file_pdf'
  | 'file_png'
  | 'file_ppt'
  | 'file_xls'
  | 'file_zip'
  | 'flame'
  | 'flask'
  | 'fork_knife'
  | 'funnel_simple'
  | 'funnel'
  | 'gauge'
  | 'gear'
  | 'ghost'
  | 'git_branch'
  | 'git_fork'
  | 'globe_stand'
  | 'globe'
  | 'graduation_cap'
  | 'graph'
  | 'hands_clapping'
  | 'handshake'
  | 'headset'
  | 'heart'
  | 'heartbeat'
  | 'house'
  | 'image'
  | 'info'
  | 'instagram_logo'
  | 'leaf'
  | 'link_break'
  | 'link'
  | 'linkedin_logo'
  | 'list_checks'
  | 'list'
  | 'lock_simple_open'
  | 'lock_simple'
  | 'magnifying_glass_minus'
  | 'magnifying_glass_plus'
  | 'magnifying_glass'
  | 'map_pin'
  | 'minus'
  | 'monitor'
  | 'moon'
  | 'needle'
  | 'notepad'
  | 'nut'
  | 'package'
  | 'paint_brush_broad'
  | 'paperclip_horizontal'
  | 'paperclip'
  | 'pencil_ruler'
  | 'pencil'
  | 'person_simple_circle'
  | 'play_circle'
  | 'plugs_connected'
  | 'plugs'
  | 'plus'
  | 'printer'
  | 'puzzle_piece'
  | 'question'
  | 'quotes'
  | 'repeat'
  | 'robot'
  | 'rocket_launch'
  | 'rows'
  | 'ruler'
  | 'scales'
  | 'selection_background'
  | 'share_network'
  | 'shield_check'
  | 'shield'
  | 'shinpinhaologo'
  | 'shopping_cart'
  | 'shuffle_up'
  | 'shuffle'
  | 'sign_in'
  | 'sign_out'
  | 'sliders_horizontal'
  | 'sliders_vertical'
  | 'smalldots_three_horisontal'
  | 'smalldots_three_vertical'
  | 'sparkle'
  | 'speaker_high'
  | 'speaker_slash'
  | 'speaker_x'
  | 'speed_high'
  | 'speed_low'
  | 'speed_medium'
  | 'spotify_logo'
  | 'square_half_horisontal'
  | 'square_half_vertical'
  | 'squares_four'
  | 'stack'
  | 'stamp'
  | 'star'
  | 'sticker'
  | 'student'
  | 'sun'
  | 'swap'
  | 'swatches'
  | 'syringe'
  | 'tag'
  | 'target'
  | 'telegram_logo'
  | 'test_tube'
  | 'thermometer_simple'
  | 'thumbs_down'
  | 'thumbs_up'
  | 'ticket'
  | 'tiktoklogo'
  | 'timer'
  | 'translate'
  | 'trash'
  | 'tree_evergreen'
  | 'tree'
  | 'truck'
  | 'twitter_logo'
  | 'user_circle'
  | 'user_minus'
  | 'user_plus'
  | 'user'
  | 'users_four'
  | 'users_three'
  | 'users_two'
  | 'warning_circle'
  | 'wechatlogo'
  | 'weishilogo'
  | 'world'
  | 'wrench'
  | 'x_circle'
  | 'x_logo'
  | 'x'
  | 'youtube_logo'
  | '3_d_printing_pictogram'
  | 'additional_cost_pictogram'
  | 'archive_box_light_pictogram'
  | 'assembly_pictogram'
  | 'awareness_pictogram'
  | 'barbell_pictogram'
  | 'barcode_pictogram'
  | 'binoculars_pictogram'
  | 'buildings_pictogram'
  | 'car_pictogram'
  | 'certified_integrator_pictogram'
  | 'certified_training_partners_pictogram'
  | 'changing_demands_pictogram'
  | 'chats_light_pictogram'
  | 'circle_wavy_check_pictogram'
  | 'cobot_line_pictogram'
  | 'cobot_pictogram'
  | 'code_light_pictogram'
  | 'collaborative_pictogram'
  | 'competitive_pictogram'
  | 'complete_solutions_pictogram'
  | 'components_pictogram'
  | 'computer_tower_light_pictogram'
  | 'cost_effective_pictogram'
  | 'currency_btc_light_pictogram'
  | 'customer_success_pictogram'
  | 'difficult_setup_pictogram'
  | 'distributors_pictogram'
  | 'drop_half_light_pictogram'
  | 'e_learning_pictogram'
  | 'expert_pictogram'
  | 'face_mask_light_pictogram'
  | 'factory_pictogram'
  | 'file_pdf_pictogram'
  | 'finishing_pictogram'
  | 'flask_pictogram'
  | 'gear_light_pictogram'
  | 'global_ecosystem_pictogram'
  | 'globe_hemisphere_west_pictogram'
  | 'globe_stand_pictogram'
  | 'glueing_dispensing_pictogram'
  | 'hamburger_pictogram'
  | 'heartbeat_light_pictogram'
  | 'iiot_pictogram'
  | 'increased_competition_pictogram'
  | 'industry_5_pictogram'
  | 'injection_molding_pictogram'
  | 'iot_pictogram'
  | 'labour_shortage_pictogram'
  | 'machine_tending_pictogram'
  | 'map_pin_line_pictogram'
  | 'map_pin_pictogram'
  | 'material_handling_old_pictogram'
  | 'material_handling_pictogram'
  | 'material_removal_pictogram'
  | 'newbizz_pictogram'
  | 'nut_pictogram'
  | 'online_training_pictogram'
  | 'palletizing_old_pictogram'
  | 'palletizing_packaging_pictogram'
  | 'palletizing_pictogram'
  | 'pick_place_pictogram'
  | 'planet_pictogram'
  | 'post_purchase_pictogram'
  | 'precision_pictogram'
  | 'predictive_maintenance_pictogram'
  | 'productive_pictogram'
  | 'projector_screen_pictogram'
  | 'quality_inspection_pictogram'
  | 'quotes_pictogram'
  | 'retention_pictogram'
  | 'risk_assessment_pictogram'
  | 'robot_pictogram'
  | 'ruler_pictogram'
  | 'safety_helmet_pictogram'
  | 'scales_pictogram'
  | 'screwdriver_pictogram'
  | 'services_pictogram'
  | 'signpost_pictogram'
  | 'sim_card_pictogram'
  | 'sliders_horizontal_light_pictogram'
  | 'space_requirements_pictogram'
  | 'sparkle_pictogram'
  | 'star_pictogram'
  | 'straightforward_pictogram'
  | 'supply_chain_pictogram'
  | 'target_light_pictogram'
  | 'timer_light_pictogram'
  | 'user_gear_light_pictogram'
  | 'user_list_pictogram'
  | 'users_three_pictogram'
  | 'warning_light_pictogram'
  | 'welding_pictogram'
  | 'wrench_pictogram'
  | 'x_circle_pictogram';
export interface SiriusIcon {
  name: IconName;
  data: string;
}
